export const skillArray = [
  {
    set: 0,
    title: "Art & Design",
    id: "paintbrush-svg",
    list: [
      {
        name: "Adobe Programs",
        id: "adobe-svg",
        sublist: ["Photoshop", "Illustrator", "AfterEffects", "InDesign", "XD"],
      },
      {
        name: "Figma",
        id: "figma-svg",
        sublist: null,
      },
      {
        name: "iPad & Procreate",
        id: "ipad-svg",
        sublist: null,
      },
    ],
  },
  {
    set: 1,
    title: "Web Development",
    id: "code-svg",
    list: [
      {
        name: "HTML5",
        id: "html5-svg",
        sublist: null,
      },
      {
        name: "CSS3",
        id: "css3-svg",
        sublist: null,
      },
      {
        name: "Javascript",
        id: "js-svg",
        sublist: null,
      },
      {
        name: "React Framework",
        id: "react-svg",
        sublist: null,
      },
      {
        name: "Visual Studio Code",
        id: "vsc-svg",
        sublist: null,
      },
      {
        name: "GSAP Plugin",
        id: "gsap-svg",
        sublist: null,
      },
    ],
  },
];
